import React from "react";
import ContactUsSection from "../components/ContactUs/ContactUs.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const ContactUs = () => {
  return (
    <>
      <MetaComponent
        title="Contact us for Business, Training & Partnerships | Aptech Limited"
        desc="Get in touch with Aptech Limited for vocational training, retail and corporate business, and institutional partnerships in India and overseas. Find office and corporate contact details. Contact Us"
        keywords="aptech contact details, aptech training solutions, aptech customer care"
      />
      <ContactUsSection />
    </>
  );
};

export default ContactUs;
